export const COLORS = [
  '#ffffff', '#ffcccc', '#ccffcc', '#ccccff', '#ffffcc', '#e6e6fa', '#ffdab9', '#e0ffff',
  '#ff69b4', '#cd5c5c', '#4b0082', '#2f4f4f', '#ffd700', '#00ced1', '#ff4500', '#32cd32'
];

export const EYES = ['round', 'happy', 'angry', 'winking', 'sleepy', 'stars'];
export const EYE_STYLES = [
  'matched', 'oval', 'button', 'dot', 'glint', 'sparkle', 'lashes', 'wide', 'sleepy', 'happy', 'stern', 'closed', 'profile',
];
export const MOUTHS = ['smile', 'o', 'neutral', 'grin', 'frown'];
export const ACCESSORIES = ['none', 'bow', 'hat', 'crown', 'glasses', 'horns', 'halo', 'bandana'];
export const SHAPES = ['classic', 'round', 'slim', 'wide'];
export const AURAS = ['none', 'flame', 'frost', 'shadow', 'holy'];
export const MARKINGS = ['none', 'scar', 'tattoo', 'freckles'];
export const TRAILS = ['none', 'sparkles', 'smoke', 'petals'];
